export default "__VITE_ASSET__CeHpb7FQ__"